import script from "./TextMultilineSingleValue.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextMultilineSingleValue.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__